export default __webpack_public_path__ + "static/media/content_img.fdcaa4a9.png";